import { createSlice } from "@reduxjs/toolkit";
import {
  DefaultAllowedRoles,
  getCurrentUserRole,
  getNavigationStackForNavBar,
} from "../../helper/userHelper";


export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    roleAllowed:
      localStorage.getItem("nbf_allowed_role") !== null
        ? JSON.parse(localStorage.getItem("nbf_allowed_role"))
        : DefaultAllowedRoles,

    name: null,
    role:
      localStorage.getItem("nbf_role") !== null
        ? localStorage.getItem("nbf_role")
        : null,
    authToken:
      localStorage.getItem("nbf_token") !== null
        ? localStorage.getItem("nbf_token")
        : null,
    navigation:localStorage.getItem("nbf_allowed_role") !== null ?
    getNavigationStackForNavBar(JSON.parse(localStorage.getItem("nbf_allowed_role")))
    : ["Home"],
  },
  reducers: {

    loggedIn(state, action) {
      state.authToken = action.payload.authToken;
      state.role = action.payload.role;
      state.name = action.payload.name;
      state.roleAllowed = getCurrentUserRole(action.payload.role);
      state.navigation = [...getNavigationStackForNavBar(state.roleAllowed)];
      localStorage.setItem("nbf_token", action.payload.authToken);
      localStorage.setItem("nbf_role", action.payload.role);
      localStorage.setItem(
        "nbf_allowed_role",
        JSON.stringify({ ...getCurrentUserRole(action.payload.role) })
      );
      localStorage.setItem("nbf_name", action.payload.name);
    },
    loggedOut(state, action) {
      state.authToken = null;
      state.role = null;
      state.name = null;
      state.roleAllowed = { ...DefaultAllowedRoles };
      localStorage.removeItem("nbf_allowed_role");
      localStorage.removeItem("nbf_role");
      localStorage.removeItem("nbf_token");
      localStorage.removeItem("nbf_name");
    },

    clearUserData: (state, action) => {
      state.usrer = null;
    },
  },
});

export const { loggedIn,loggedOut, clearUserData } = currentUserSlice.actions;
export default currentUserSlice.reducer;
